import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    checkbox: {
      margin: '0px !important',
      alignItems: 'flex-start !important',
      '&.Mui-disabled': {
        cursor: 'not-allowed !important',
      },
      '& input': {
        display: 'none',
      },
      '& .MuiCheckbox-root': {
        padding: '0px 8px 0px 0px !important',
        '& svg': {
          width: '24px',
          height: '24px',
        },
      },
      '& .Mui-disabled': {
        opacity: 0.5,
        color: `${STYLE.COLOR.TEXT1} !important`,
      },
      '& .MuiFormControlLabel-label': {
        alignSelf: 'center',
        fontSize: '14px !important',
        lineHeight: '20px !important',
      },
    },
  }),
);
